import React, { Component } from 'react'
import getLabel from '../../utilities/label.js'

export default class ResetPasswordForm extends Component {
  constructor(props){
    super(props)
    this.state = {
      requireCurrentPw: this.props.location ? true : false,
      currentPassword: '',
      newPassword: '',
      confirmationPassword: '',
      errorMessage: getLabel('password_complexity_rules')
    }
    if (this.props.setActiveTab) {
      this.props.setActiveTab('homepage')
    }
    this.currentPasswordCheck = this.currentPasswordCheck.bind(this)
    this.changePermanentPassword = this.changePermanentPassword.bind(this)
    this.changePasswordConfirmation = this.changePasswordConfirmation.bind(this)
    this.submit = this.submit.bind(this)
    window.trackPage('ChangePasswordScreen')
  }

  currentPasswordCheck(e){
    this.setState({currentPassword: e.target.value})
  }

  changePermanentPassword(e){
    const value = e.target.value
    this.validate({
      newPassword: value,
      confirmationPassword: this.state.confirmationPassword
    })
  }

  changePasswordConfirmation(e){
    const value = e.target.value
    this.validate({
      newPassword: this.state.newPassword,
      confirmationPassword: value
    })
  }

  validate(data){
    const { newPassword, confirmationPassword } = data
    const trailingWhitespace = 
      newPassword[0] === ' ' ||
      newPassword[newPassword.length - 1] === ' '
    let errorMessage = ''
    if (newPassword.length < 8) {
      errorMessage = getLabel('weak_password')
    } else if (trailingWhitespace) {
      errorMessage = getLabel('trailing_whitespace')
    } else if (newPassword !== confirmationPassword) {
      errorMessage = getLabel('password_mismatch_static')
    }
    this.setState({
      newPassword: newPassword,
      confirmationPassword: confirmationPassword,
      errorMessage: errorMessage
    })
  }

  submit(e){
    e.preventDefault()
    const requireCurrentPw = this.props.location ? this.props.location.state.requireCurrentPw : false
    const password_action = requireCurrentPw ? 'change_password' : 'reset_password'
    const { currentPassword, newPassword, confirmationPassword, errorMessage } = this.state
    let data = {}
    if(requireCurrentPw) {
      data = {
        user: {
          current_password: currentPassword,
          new_password: newPassword,
          confirmation_password: confirmationPassword
        }
      }
    } else {
      data = {
        user: {
          new_password: newPassword,
          confirmation_password: confirmationPassword
        }
      }
    }
    if (!errorMessage) {
      this.props.setPermanentPassword({
        key: password_action,
        data: data,
        callback: () => this.props.history.push('settings_and_support')
      })
    }
  }

  cancel() {
    this.props.history.push('settings_and_support')
  }

  render() {
    var requireCurrentPw = this.props.location ? this.props.location.state.requireCurrentPw : false
    const { currentPassword, newPassword, confirmationPassword, errorMessage } = this.state
    return (
      <div className='reset-password-form'>
        <div className='page-title-nav row' style={{ marginBottom: '20px' }}>
          <div className='col-4 offset-4 page-title-name'>
            <h6>{ getLabel('change_password') }</h6>
          </div>
        </div>
        <form>
          { requireCurrentPw &&
            <input
              type='password'
              className='form-control'
              placeholder={ getLabel('current_password') }
              value={ currentPassword }
              onChange={ this.currentPasswordCheck } />
          }
          <input
            type='password'
            className='form-control'
            placeholder={ getLabel('new_password') }
            value={ newPassword }
            onChange={ this.changePermanentPassword } />
          <input
            type='password'
            className='form-control'
            placeholder={ getLabel('password_again') }
            value={ confirmationPassword }
            onChange={ this.changePasswordConfirmation } />
          <div>{ errorMessage }</div>
          <br />
          <button
            onClick={ this.submit }
            className='submit margin-top-10' disabled={ errorMessage }>
            { getLabel('submit') }
          </button>
          <button
            className='cancel-button'
            onClick={this.cancel.bind(this)} >
            { getLabel('cancel')}
          </button>
        </form>
      </div>
    )
  }
}
